import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { DeclarationCustomsFlowType } from '@e-origin/shared';

import { ExitProofLogsSchema } from './schemas/ExitProofLogsSchema';

const c = initContract();

export const idmsContract = c.router({
  customsSync: {
    method: 'POST',
    path: '/idms/:batchId/customs-sync',
    pathParams: z.object({ batchId: z.string().length(24) }),
    body: c.noBody(),
    responses: {
      200: z.object({}),
    },
  },
  sendAllDeclarations: {
    method: 'POST',
    path: '/idms/:batchId/send-all-declarations',
    pathParams: z.object({ batchId: z.string().length(24) }),
    body: z.object({ flow: z.nativeEnum(DeclarationCustomsFlowType).optional() }),
    responses: {
      200: z.object({}),
    },
  },
  sendOneDeclaration: {
    method: 'POST',
    path: '/idms/send-one-declaration',
    body: z.object({
      LRN: z.string().optional(),
      declarationId: z.string().optional(),
      flow: z.nativeEnum(DeclarationCustomsFlowType).optional(),
    }),
    responses: {
      200: z.object({}),
      429: z.object({ error: z.string(), message: z.string(), retryAfter: z.number() }),
    },
  },
  invalidateAll: {
    method: 'POST',
    path: '/idms/invalidate-all',
    body: z.object({
      reason: z.string(),
      batchId: z.string(),
      invalidationMotivation: z.string().optional(),
    }),
    responses: {
      200: z.object({}),
    },
  },
  invalidate: {
    method: 'POST',
    path: '/idms/invalidate',
    body: z.object({
      reason: z.string(),
      declarationId: z.string().optional(),
      LRN: z.string().optional(),
      invalidationMotivation: z.string().optional(),
    }),
    responses: {
      200: z.object({}),
    },
  },
  sendProofOfExit: {
    method: 'POST',
    path: '/idms/send-proof-of-exit',
    body: z.object({ LRN: z.string(), proofOfExit: ExitProofLogsSchema }),
    responses: {
      200: z.object({}),
    },
  },
  sendDocuments: {
    method: 'POST',
    path: '/idms/send-documents/:declarationId',
    pathParams: z.object({ declarationId: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({ message: z.string(), declaration: z.any() }),
    },
  },
  sendNoDocumentsNotification: {
    method: 'POST',
    path: '/idms/send-no-documents-notification/:declarationId',
    pathParams: z.object({ declarationId: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
});
